import {useHotelsRuntimeStore} from '~src/stores/hotels/HotelsRuntimeStore'
import {useAccommodationRuntimeData} from '~/composables/hotel'
import {thumbnailUrl} from '~/utils/helpers'

export default async () => {
    const route = useRoute()
    const hotelsRuntimeStore = useHotelsRuntimeStore()
    const cmsStore = useCmsStore()
    await callOnce(async () => {
        await hotelsRuntimeStore.loadRouteMap(route.params.name)
        await useAccommodationRuntimeData(route, +route.query.cityId || hotelsRuntimeStore.routeMap.cityId)
    })

    const {fullUrl} = useUrl()
    const title = computed(() => {
        const info: any = hotelsRuntimeStore.hotelInfoResponse.hotelDescriptionInfo
        const city = hotelsRuntimeStore.city
        return `- ${info.hotelName}, ${city.name}`
    })

    useHead({
        link: [
            {
                rel: 'canonical',
                href: fullUrl(route.path),
            },
        ],
        title,
        meta: computed(() => {
            const info: any = hotelsRuntimeStore.hotelInfoResponse.hotelDescriptionInfo
            const shortDescription = info.descriptions?.description.find(({type}) => type === 'short')
            const image = info.images.image[0]
            return [
                {
                    hid: 'og:title',
                    name: 'og:title',
                    content: cmsStore.layoutSettings.head.titleTemplate.replace('%s', title.value),
                },
                ...(shortDescription
                    ? [
                          {
                              hid: 'description',
                              name: 'description',
                              content: shortDescription.description.replace(/<\/?[^>]+(>|$)/g, ''),
                          },
                      ]
                    : []),
                ...(image ? [{hid: 'og:image', name: 'og:image', content: thumbnailUrl(image.url, 300, fullUrl)}] : []),
            ]
        }),
    })
}
